export const server = {
    apiURL: process.env.VUE_APP_ROOT_API,
    baseURL: process.env.VUE_APP_ROOT,
    chbeeDomain: process.env.VUE_APP_CHARGEBEE_DOMAIN,
    chbeeApiKey: process.env.VUE_APP_CHARGEBEE_API_KEY
}
